(function () {
  "use strict";

  if (window.__NECrossSellDiscountPipelineV1) return;
  window.__NECrossSellDiscountPipelineV1 = true;

  var cache = Object.create(null);
  var pending = Object.create(null);
  var cacheGeneration = 0;
  var lastCode = "";
  var updateTimer = null;
  var rafHandle = null;

  function normalizeCode(code) {
    return String(code || "").trim().toUpperCase();
  }

  function formatMoney(cents) {
    return window.NE.Utils.formatMoney(cents);
  }

  function getActiveCode() {
    try {
      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.getDetails === "function"
      ) {
        var details = window.NE.DiscountTracker.getDetails();
        return details && details.code ? normalizeCode(details.code) : "";
      }
    } catch (error) {}

    return "";
  }

  function fetchProductDiscount(code, productId) {
    var key = code + ":" + productId;

    if (Object.prototype.hasOwnProperty.call(cache, key)) {
      return Promise.resolve(cache[key]);
    }
    if (pending[key]) return pending[key];
    if (
      !window.NE ||
      !window.NE.DiscountTracker ||
      typeof window.NE.DiscountTracker.fetchProductDiscount !== "function"
    ) {
      return Promise.resolve(null);
    }

    var generation = cacheGeneration;
    var request = window.NE.DiscountTracker.fetchProductDiscount(code, productId)
      .then(function (value) {
        if (generation !== cacheGeneration || value === null || value === undefined) {
          return null;
        }
        var percentage = Number(value || 0);
        cache[key] = percentage;
        return percentage;
      })
      .catch(function () {
        return null;
      })
      .then(function (value) {
        if (pending[key] === request) delete pending[key];
        return value;
      });

    pending[key] = request;
    return request;
  }

  function resetPrice(box) {
    var priceElement = box.querySelector("[data-cross-sell-current-price]");
    var originalElement = box.querySelector("[data-cross-sell-original-price]");

    if (priceElement) {
      priceElement.classList.remove("sale");
    }
    if (originalElement) originalElement.style.display = "none";
    box.removeAttribute("data-cross-sell-update-signature");
  }

  function updateBox(box, code) {
    var productId = String(box.getAttribute("data-product-id") || "");
    var basePrice = Number(box.getAttribute("data-base-price") || 0);

    resetPrice(box);
    if (!code || !productId || !basePrice) return;

    var signature = code + ":" + productId + ":" + basePrice;
    box.setAttribute("data-cross-sell-update-signature", signature);

    fetchProductDiscount(code, productId).then(function (percentage) {
      if (!box.isConnected) return;
      if (box.getAttribute("data-cross-sell-update-signature") !== signature) return;
      if (percentage === null || Number(percentage) <= 0) {
        resetPrice(box);
        return;
      }

      var priceElement = box.querySelector("[data-cross-sell-current-price]");
      var originalElement = box.querySelector("[data-cross-sell-original-price]");
      var discountedPrice = Math.round(basePrice * (1 - Number(percentage) / 100));

      if (priceElement) {
        priceElement.textContent = formatMoney(discountedPrice);
        priceElement.classList.add("sale");
      }
      if (originalElement) {
        originalElement.textContent = formatMoney(basePrice);
        originalElement.style.display = "";
      }
    });
  }

  function updateAll() {
    var code = getActiveCode();
    if (code !== lastCode) {
      cacheGeneration += 1;
      cache = Object.create(null);
      pending = Object.create(null);
      lastCode = code;
    }

    document.querySelectorAll("[data-cross-sell-price]").forEach(function (box) {
      updateBox(box, code);
    });
  }

  function requestUpdate(options) {
    options = options || {};
    if (options.clearCache) {
      cacheGeneration += 1;
      cache = Object.create(null);
      pending = Object.create(null);
    }

    clearTimeout(updateTimer);
    cancelAnimationFrame(rafHandle);
    updateTimer = setTimeout(function () {
      rafHandle = window.requestAnimationFrame(updateAll);
    }, options.immediate ? 0 : 150);
  }

  function observeCartDom() {
    if (!document.body) return;
    new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches("[data-cross-sells], [data-cross-sell-price]") ||
            node.querySelector("[data-cross-sells], [data-cross-sell-price]")
          );
        });
      });
      if (shouldUpdate) requestUpdate();
    }).observe(document.body, { childList: true, subtree: true });
  }

  ["quick-cart:updated", "cart:updated", "theme:pagination:loaded", "ne:cross-sells:update"]
    .forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        requestUpdate();
      });
    });

  ["ne:discount-code-updated", "ne:discount-code-cleared"].forEach(function (eventName) {
    window.addEventListener(eventName, function () {
      requestUpdate({ clearCache: true });
    });
  });

  window.NECrossSellDiscountPrice = {
    update: requestUpdate,
    updateNow: updateAll,
    clearCache: function () {
      requestUpdate({ clearCache: true });
    },
  };

  function init() {
    observeCartDom();
    requestUpdate({ immediate: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
